export const ugovor_o_GDPR_izvrsitelj = {
    templateId: 91,
    category: 9,
    templateTitle: 'Ugovor o povjerljivosti i izvršenju obrade osobnih podataka',
    templateDescription: `<p>Ukoliko za voditelja obrade osobnih podataka poslove obrade osobnih podataka obavlja izvršitelj obrade, Uredbom je propisana obveza zaključenja ugovora te su propisani i obvezni sastojci navedenog ugovora. </p>`,
    description: `
    <h5><strong>OPIS I SVRHA DOKUMENTA</strong></h5>
    <p>Osobni podaci su svi podaci koji se odnose na pojedinca čiji je identitet utvrđen ili se može utvrditi, a odnose se npr. na ime, identifikacijski broj, podaci o lokaciji, mrežni identifikator ili uz pomoć jednog ili više čimbenika svojstvenih za fizički, fiziološki, genetski, mentalni, ekonomski, kulturni ili socijalni identitet tog pojedinca.</p>
    <p>Voditelj obrade osobnih podataka je fizička ili pravna osoba, tijelo javne vlasti, agencija ili drugo tijelo koje samo ili zajedno s drugima određuje svrhe i sredstva obrade osobnih podataka.</p>
    <p>Pojednostavljenim rječnikom rečeno, svaki poslodavac ujedno je i voditelj obrade.</p>

    <p>Voditelj obrade odgovoran je za usklađenost s načelima obrade osobnih podataka te navedeno mora moći dokazati.</p>
    <p>Poslodavac ne mora samostalno obrađivati sve osobne podatke, nego obradu (dijelom ili u cijelosti) može povjeriti izvršitelju obrade koji može u njegovo ime obavljati obradu osobnih podataka.</p>
    <p>Opća uredba EU o zaštiti osobnih podataka (dalje u tekstu: Uredba) propisuje obvezu sklapanja ugovora ili drugog pravnog akta između voditelja obrade i izvršitelja obrade te propisuje i obvezne sastojke navedenog dokumenta.</p>
    <p>Pri povjeravanju aktivnosti obrade izvršitelju obrade, voditelj obrade trebao bi angažirati samo izvršitelje obrade koji u zadovoljavajućoj mjeri jamče, osobito u pogledu stručnog znanja, pouzdanosti i resursa, provedbu tehničkih i organizacijskih mjera koje udovoljavaju zahtjevima iz ove Uredbe, među ostalim i provedbu mjera i u pogledu sigurnosti obrade.</p>
    <p>Osim toga, izvršitelj obrade trebao bi pomagati voditelju obrade u osiguravanju usklađenosti s obvezama koje proizlaze iz provedbe procjene učinka na zaštitu podataka i iz prethodnog savjetovanja s nadzornim tijelom.</p>
    <p>Sukladno načelo cjelovitosti i povjerljivosti u obradi podataka, osobni podaci bi trebali biti obrađivani na način kojim se osigurava odgovarajuća sigurnost osobnih podataka, uključujući zaštitu od neovlaštene ili nezakonite obrade te od slučajnog gubitka, uništenja ili oštećenja primjenom odgovarajućih tehničkih ili organizacijskih mjera.</p>
    <p>Također, voditelj obrade i izvršitelj obrade provode i odgovarajuće tehničke i organizacijske mjere kako bi osigurali odgovarajuću razinu sigurnosti s obzirom na rizik.</p>
    <p>Voditelj obrade i izvršitelj obrade poduzimaju mjere kako bi osigurali da svaki pojedinac koji djeluje pod odgovornošću voditelja obrade ili izvršitelja obrade, a koji ima pristup osobnim podacima, ne obrađuje te podatke ako se ta obrada ne obavlja prema uputama voditelja obrade.</p>
    <p>Dokument u nastavku (Ugovor) je prijedlog primjerka uređenja odnosa između voditelja obrade i izvršitelja obrade, a kako to propisuje Uredba. </p>
    <p>Važno je reći da je obveza izvršitelja obrade osigurati da se osobe ovlaštene za obradu osobnih podataka prethodno obvežu na poštovanje povjerljivosti ili da podliježu zakonskim obvezama o povjerljivosti.</p>
    <p>U tom smislu, izvršitelj obrade je dužan osigurati potpis na Izjavu o povjerljivosti svih osoba koje imaju ovlaštenje obrađivati osobne podatke za izvršitelja obrade.</p>
    <p>Primjerak takve izjave se nalazi <a class="local-link" href="/contract?template=91.1">ovdje</a>.</p>
    <p></p>
    <p><strong>NAPOMENA: Ovaj tekst je uvodno dan radi prikazivanja bitnih odredbe odnosno obveza navedenih u Uredbi te predstavlja samo dio obveza odnosno procesa koje treba ispuniti radi usklađenja postupanja s Uredbom,  koji se inače sastoji od čitavog niza mjera i dokumenata. </strong></p>
    

    <h5><strong>PRAVNA OSNOVA</strong></h5>
    <p>UREDBA (EU) 2016/679 EUROPSKOG PARLAMENTA I VIJEĆA od 27. travnja 2016. o zaštiti pojedinaca u vezi s obradom osobnih podataka i o slobodnom kretanju takvih podataka te o stavljanju izvan snage Direktive 95/46/EZ (Opća uredba o zaštiti podataka).</p>
  `,

    sides: [
        {
            signature: ' Za Voditelja obrade:',
            inputs: [{
                type: "input",
                required: true,
                placeholder: "Poslovni subjekt",
              },
              {
                type: "input",
                required: true,
                placeholder: "Ulica i kućni broj",
              },
              {
                type: "input",
                required: true,
                placeholder: "Mjesto",
              },
              {
                type: "input",
                required: true,
                placeholder: "OIB",
              },
              {
                type: "input",
                placeholder: "Zastupa",
                inSignature: true,
              },
              {
                type: "input",
                placeholder: "Funkcija",
                inSignature: true,
              }],
            suffix: ' (u daljnjem tekstu: Voditelj obrade)',
            delimiter: `i`
        },
        {
            signature: ' Za Izvršitelja obrade:',
            inputs: [{
                type: "input",
                required: true,
                placeholder: "Poslovni subjekt",
              },
              {
                type: "input",
                required: true,
                placeholder: "Ulica i kućni broj",
              },
              {
                type: "input",
                required: true,
                placeholder: "Mjesto",
              },
              {
                type: "input",
                required: true,
                placeholder: "OIB",
              },
              {
                type: "input",
                placeholder: "Zastupa",
                inSignature: true,
              },
              {
                type: "input",
                placeholder: "Funkcija",
                inSignature: true,
              }],
            suffix: ' (u daljnjem tekstu: Izvršitelj obrade),'
        }
    ],

    headline: 'zaključuju sljedeći',
    title: 'UGOVOR O POVJERLJIVOSTI I IZVRŠENJU OBRADE OSOBNIH  PODATAKA',
    noArticleNumbers: false,

    articles: [
        {
            title: 'UVODNE ODREDBE',
            mandatory: false,
            statements: [
                {
                    type: 'text',
                    required: false,
                    mandatory: true,
                    editable: true,
                    content: 'Ugovorne strane suglasno utvrđuju da se nalaze u poslovnom odnosu u kojemu Izvršitelj obrade obavlja knjigovodstvene usluge za Voditelja obrade. \r\nU navedenom poslovnom odnosu, u okviru obavljanja knjigovodstvenih usluga,  Izvršitelj obrade u ime Voditelja obrađuje osobne podatke (dalje u tekstu: obrada).\r\nOvim Ugovorom ugovorne strane uređuju predmet obrade, prirodu obrade, svrhu obrade, kategorije ispitanika,  vrste osobnih podataka, trajanje obrade, obveze Izvršitelja obrade, obveze Voditelja obrade  međusobna prava i obveze, povjerljivost obrade i trajanje Ugovora.\r\nIzvršitelj jamči da u pogledu stručnog znanja, pouzdanosti i resursa, provedbe tehničkih i organizacijskih mjera te sigurnosti obrade udovoljava zahtjevima Opće uredbe EU o zaštiti osobnih podataka (dalje u tekstu: Uredba) odnosno da se njome osigurava zaštita prava ispitanika.',
                    value: '',
                },
],         
        },
        {
            title: 'PREDMET UGOVORA',
            mandatory: false,
            statements: [
                {
                    type: 'choice',
                    mandatory: true,
                    editable: false,
                    choices: [
                        {
                            parts: [
                                {
                                    type: 'text',
                                    content: 'U provedbi ovog Ugovora,  obrađuju se opće kategorije osobnih podataka kako je to određeno u definicijama Uredbe.'
                                }
                            ]
                        },
                        {
                            parts: [
                                {
                                    type: 'text',
                                    content: 'U provedbi ovog Ugovora,  obrađuju se posebne kategorije osobnih podataka kako je to određeno u definicijama Uredbe.'
                                }
                            ]
                        },
                        {
                            parts: [
                                {
                                    type: 'text',
                                    content: 'U provedbi ovog Ugovora,  obrađuju se opće i posebne kategorije osobnih podataka kako je to određeno u definicijama Uredbe.'
                             }]
                        }
                    ],
                    value: '',
                }
            ]
        },
        {
            title: 'SVRHA OBRADE',
            mandatory: true,
            exampleContent: true,
            statements: [
                {
                    type: 'text',
                    mandatory: true,
                    editable: false,
                    content: 'Obrada je nužna radi: \r\n',
                },
                {
                    type: 'text',
                    required: true,
                    mandatory: true,
                    editable: true,
                    content: '- ispunjavanja pravnih obveza voditelja obrade (pozitivni propisi Republike Hrvatske) > u pogledu podataka o radnicima i drugim osoba angažiranih od strane Voditelja obrade (studenti, osobe na stručnom osposobljavanju bez zasnivanja radnog odnosa te druge osobe o kojima se vode posebne evidencije) te u pogledu podataka o kupcima/korisnicima usluga te ostalim poslovnim partnerima Voditelja obrade,\r\n- legitimnih interesa voditelja obrade > u pogledu dostave promotivnih materijala, obavijesti i ponuda kupcima/korisnicima usluga te ostalim poslovnim partnerima Voditelja obrade.',
                    help: 'Ovdje pobliže opisujete uvjete suradnje odnosno poslovnog dogovora, npr. - količine robe, cijene, isporuku, rokove i način plaćanja i sl. ili vrste usluga, cijenu usluge, isporuku, rokove i način plaćanja.',
                    value: '',
                },
            ],
            value: '',
        }, 
        {
            title: 'PREDMET OBRADE',
            mandatory: true,
            exampleContent: true,
            statements: [
                {
                    type: 'text',
                    required: true,
                    mandatory: true,
                    editable: true,
                    content: 'Predmet obrade osobni podaci kako to uređuju odredbe Uredbe te odredbe ovog Ugovora.',
                    value: '',
                },
            ],
            value: '',
        },
        {
            title: 'PRIRODA OBRADE',
            mandatory: true,
            exampleContent: true,
            statements: [
                {
                    type: 'text',
                    required: true,
                    mandatory: true,
                    editable: true,
                    content: 'U provedbi ovog Ugovora, obrađuju se opće kategorije osobnih podataka kako je to određeno u definicijama Uredbe.',
                    value: '',
                },
            ],
            value: '',
        },  
        {
            title: 'KATEGORIJE ISPITANIKA',
            mandatory: true,
            exampleContent: true,
            statements: [
                {
                    type: 'text',
                    required: true,
                    mandatory: true,
                    editable: true,
                    content: 'Ispitanici su fizičke osobe – radnici, i druge osobe angažirane od Voditelja obrade (studenti, osobe na stručnom osposobljavanju bez zasnivanja radnog odnosa te druge osobe o kojima se vode posebne evidencije) te fizičke osobe koje se nalaze u poslovnom odnosu s Voditeljem obrade kao kupci/korisnici usluga te poslovni partneri Voditelja obrade. ',
                    value: '',
                },
            ],
            value: '',
        },
        {
            title: 'VRSTE OSOBNIH PODATAKA',
            mandatory: true,
            exampleContent: true,
            statements: [
                {
                    type: 'text',
                    required: true,
                    mandatory: true,
                    editable: true,
                    content: 'U odnosu na radnike i druge osobe angažirane od strane Voditelja obrade (studenti, osobe na stručnom osposobljavanju bez zasnivanja radnog odnosa te druge osobe o kojima se vode posebne evidencije), obrađuju se neki ili svi od sljedećih podataka:\r\n- ime i prezime,\r\n- adresu, \r\n- osobni identifikacijski broj i/ili drugi identifikacijski broj,\r\n- datum rođenja / JMBG, \r\n- osobni broj iz e-radne knjižice,\r\n- broj tekućeg ili žiro-računa,\r\n- dokaz o završenom školovanju (svjedodžba, diploma i sl.), \r\n- uvjerenje o zdravstvenoj sposobnosti i sl.,\r\npreduvjet za sklapanje i izvršenje Ugovora o radu odnosno svih obveza iz radnog odnosa te je navedene podatke u tom smislu Radnik pružio Poslodavcu. \r\nRadnik svojim potpisom na ovom Ugovoru potvrđuje da mu je Poslodavac dostavio informacije koje je dužan dostaviti u trenutku prikupljanja gore navedenih osobnih podataka, a prema Općoj uredbi o zaštiti podataka i to:\r\n- identitet i kontaktne podatke voditelja obrade odnosno predstavnika voditelja obrade, \r\n- svrhe obrade radi kojih se upotrebljavaju osobni podaci, kao i pravnu osnovu za obradu, \r\n- primatelje ili kategorije primatelja osobnih podataka, \r\n- razdoblje u kojem će osobni podaci biti pohranjeni ili, ako to nije moguće, kriterije kojima se utvrdilo to razdoblje, \r\n- postojanje prava da se od voditelja obrade zatraži pristup osobnim podacima i ispravak ili brisanje osobnih podataka ili ograničavanje obrade koji se odnose na ispitanika ili prava na ulaganje prigovora na obradu takvih te prava na prenosivost podataka, \r\n- pravo na podnošenje prigovora nadzornom tijelu. \r\nU odnosu na kupce/korisnike usluga odnosno ostale poslovne partnera Voditelja obrade obrađuju neki ili svi od sljedećih podataka:\r\n- ime i prezime,\r\n- osobni identifikacijski broj i/ili drugi identifikacijski broj,\r\n- podaci o lokaciji – adresi,\r\n- broj telefona/mobitela,\r\n- e-mail adresa.',
                    value: '',
                },
            
            ],
            value: '',
        }, 
        {
            title: 'TRAJANJE OBRADE',
            mandatory: true,
            exampleContent: true,
            statements: [
                {
                    type: 'text',
                    required: true,
                    mandatory: true,
                    editable: true,
                    content: 'U odnosu na kupce/korisnike usluga odnosno osobe angažirane od strane Voditelja obrade, obrada osobnih podataka obavlja se sve do isteka roka u kojemu je potrebno čuvati navedenu dokumentaciju propisanog Zakonom o računovodstvu (trenutno 11 godina). Nakon navedenog perioda Izvršitelj obrade će predati dokumentaciju Voditelju obrade. \r\nU odnosu na radnike i druge osobe angažirane od strane Voditelja obrade (studenti, osobe na stručnom osposobljavanju bez zasnivanja radnog odnosa te druge osobe o kojima se vode posebne evidencije) sukladno Pravilniku o sadržaju i načinu vođenja evidencije o radnicima te drugim propisima, navedeni podaci čuvaju se trajno te u tom smislu i obrada osobnih podataka traje trajno. \r\nTrajanje obrade osobnih podataka iz stavka 1. i 2. ovog članka može trajati kraće u slučaju prekida poslovnog odnosa. U tom slučaju Izvršitelj obrade će predati dokumentaciju Voditelju obrade po prekidu poslovnog odnosa i povratu ostale poslovne dokumentacije.',
                    value: '',
                },
            ],
            value: '',
        },  
        {
            title: 'OBVEZE IZVRŠITELJA OBRADE',
            mandatory: true,
            exampleContent: true,
            statements: [
                {
                    type: 'text',
                    required: true,
                    mandatory: true,
                    editable: true,
                    content: 'Izvršitelj obrade ima sljedeće obveze:\r\n- zakonito, pošteno i transparentno obrađivati podatke s obzirom na ispitanika,\r\n- osigurati da su podaci prikupljeni u posebne, izričite i zakonite svrhe te se dalje ne smiju obrađivati na način koji nije u skladu s tim svrhama,\r\n- osigurati da su osobni podaci primjereni, relevantni i ograničeni na ono što je nužno u odnosu na svrhe u koje se obrađuju,\r\n- osigurati da su osobni podaci točni i prema potrebi ažurni, \r\n- osigurati da su osobni podaci točni i prema potrebi ažurni,\r\n- osigurati da su osobni podaci čuvani u obliku koji omogućuje identifikaciju ispitanika samo onoliko dugo koliko je potrebno u svrhe radi kojih se osobni podaci obrađuju,\r\n- obrađivati osobne podatke na način kojim se osigurava odgovarajuća sigurnost osobnih podataka, uključujući zaštitu od neovlaštene ili nezakonite obrade te od slučajnog gubitka,uništenja ili oštećenja primjenom odgovarajućih tehničkih ili organizacijskih mjera, \r\n- bez prethodnog posebnog ili općeg pisanog odobrenja Voditelja obrade,  ne smije angažirati drugog Izvršitelja obrade. U slučaju općeg pisanog odobrenja, Izvršitelj obrade obavješćuje voditelja obrade o svim planiranim izmjenama u vezi s dodavanjem ili zamjenom drugih Izvršitelja obrade kako bi time Voditelju obrade omogućio da uloži prigovor na takve izmjene.\r\nAko Izvršitelj obrade angažira drugog Izvršitelja obrade za provođenje posebnih aktivnosti obrade u ime Voditelja obrade, iste obveze za zaštitu podataka kao one navedene u ovom Ugovoru nameću se tom drugom Izvršitelju obrade ugovorom ili drugim pravnim aktom u skladu s pravom Unije ili pravom države članice, a osobito obveza davanja dostatnih jamstava za provedbu odgovarajućih tehničkih i organizacijskih mjera na način da se obradom udovoljava zahtjevima iz ove Uredbe. \r\nAko taj drugi Izvršitelj obrade ne ispunjava obveze zaštite podataka, početni Izvršitelj obrade ostaje u cijelosti odgovoran Voditelju obrade za izvršavanje obveza tog drugog Izvršitelja obrade,\r\n- obrađivati osobne podatke samo prema zabilježenim uputama Voditelja obrade, među ostalim s obzirom na prijenose osobnih podataka trećoj zemlji ili međunarodnoj organizaciji, osim ako to nalaže pravo Unije ili pravo države članice kojem podliježe izvršitelj obrade; u tom slučaju izvršitelj obrade izvješćuje voditelja obrade o tom pravnom zahtjevu prije obrade, osim ako se tim pravom zabranjuje takvo izvješćivanje zbog važnih razloga od javnog interesa,\r\n- osigurati  da su se osobe ovlaštene za obradu osobnih podataka (radnici Izvršitelja obrade i sl.) obvezale na poštovanje povjerljivosti ili da podliježu zakonskim obvezama o povjerljivosti, \r\n- provoditi odgovarajuće tehničke i organizacijske mjere kako osigurao odgovarajuću razinu sigurnosti s obzirom na rizik  te u tom smislu prema potrebi poduzima sljedeće radnje: obavlja pseudonimizaciju i enkripciju osobnih podataka, osigurava trajnu povjerljivost, cjelovitost, dostupnost i otpornost sustava i usluga obrade, osigurava mogućnost pravodobne ponovne uspostave dostupnosti osobnih podataka i pristupa njima u slučaju fizičkog ili tehničkog incidenta, provodi proces za redovno testiranje, ocjenjivanje i procjenjivanje učinkovitosti tehničkih i organizacijskih mjera za osiguravanje sigurnosti obrade, \r\n- uzimajući u obzir prirodu obrade, pomaže Voditelju obrade putem odgovarajućih tehničkih i organizacijskih mjera, koliko je to moguće, da ispuni obvezu Voditelja obrade u pogledu odgovaranja na zahtjeve za ostvarivanje prava ispitanika koja su utvrđena u poglavlju III Uredbe (informacije i pristup osobnim podacima, ispravak i brisanje, pravo na ograničenje obrade, obveza izvješćivanja u vezi s ispravkom ili brisanjem osobnih podataka ili ograničenjem obrade, pravo na prenosivost podataka),  \r\n- pomaže Voditelju obrade u osiguravanju usklađenosti s obvezama u skladu s člancima od 32. do 36. Uredbe (sigurnost obrade, Izvješćivanje nadzornog tijela o povredi osobnih podataka, Obavješćivanje ispitanika o povredi osobnih podataka, Procjena učinka na zaštitu osobnih podataka, Prethodno savjetovanje s nadzornim tijelom), uzimajući u obzir prirodu obrade i informacije koje su dostupne Izvršitelju obrade, \r\n- po izboru Voditelja obrade, briše ili vraća Voditelju obrade sve osobne podatke nakon dovršetka pružanja usluga vezanih za obradu te briše postojeće kopije osim ako sukladno pravu Unije ili pravu države članice postoji obveza pohrane osobnih podataka,  \r\n- Voditelju obrade stavlja na raspolaganje sve informacije koje su neophodne za dokazivanje poštovanja obveza utvrđenih u ovom članku i koje omogućuju revizije, uključujući inspekcije, koje provodi voditelj obrade ili drugi revizor kojeg je ovlastio Voditelj obrade, te im doprinose, ali i odmah obavješćuje Voditelja obrade ako prema njegovu mišljenju određena uputa krši ovu Uredbu ili druge odredbe Unije ili države članice o zaštiti podataka. \r\nPrema potrebi i na zahtjev Voditelja obrade, Izvršitelj obrade trebao bi pomagati Voditelju obrade u osiguravanju usklađenosti s obvezama koje proizlaze iz provedbe procjene učinka na zaštitu podataka i iz prethodnog savjetovanja s nadzornim tijelom. \r\nAko Izvršitelj obrade krši odredbe ovog Ugovora utvrđivanjem svrhe i načine obrade podataka, Izvršitelj obrade smatra se voditeljem obrade, a sukladno odredba Uredbe.',
                    help: "Ove obveze su striktno propisane odredbama Uredbe, prije bilo kojeg brisanja ili uređivanja molimo pogledajte odredbe Uredbe.",
                    value: '',
                },
            ],
            value: '',
        },  
        {
            title: 'OBVEZE VODITELJA OBRADE',
            mandatory: true,
            exampleContent: true,
            statements: [
                {
                    type: 'text',
                    required: true,
                    mandatory: true,
                    editable: true,
                    content: 'Voditelj obrade se obvezuje davati Izvršitelju obrade upute za obradu podataka u pisanom obliku, radi mogućnosti dokazivanja te po potrebi davati određena razjašnjenja, osiguravati pomoć i sl..',
                    value: '',
                },
        
            ],
            value: '',
        },  
        {
            title: 'MEĐUSOBNE OBVEZE UGOVORNIH STRANA',
            mandatory: true,
            exampleContent: true,
            statements: [
                {
                    type: 'text',
                    required: true,
                    mandatory: true,
                    editable: true,
                    content: 'Voditelj obrade i Izvršitelj obrade te, ako je to primjenjivo, njihovi predstavnici, na zahtjev surađuju s nadzornim tijelom u ispunjavanju njegovih zadaća. \r\nVoditelj obrade i Izvršitelj obrade poduzimaju mjere kako bi osigurali da svaki pojedinac koji djeluje pod odgovornošću Voditelja obrade ili Izvršitelja obrade, a koji ima pristup osobnim podacima, ne obrađuje te podatke ako to nije prema uputama Voditelja obrade, osim ako je to obvezan učiniti prema pravu Unije ili pravu države članice.',
                    value: '',
                },
        
            ],
            value: '',
        },  
        {
            title: 'POVJERLJIVOST',
            mandatory: true,
            exampleContent: true,
            statements: [
                {
                    type: 'text',
                    required: true,
                    mandatory: true,
                    editable: true,
                    content: 'S obzirom na odredbe ovog Ugovora i uredbe koje se odnose na poštivanje povjerljivosti, Izvršitelj obrade je dužan osigurati da se prije obrade osobnih podataka, osobe ovlaštene za obradu osobnih podataka obvežu na poštovanje povjerljivosti  s obzirom na načelo pouzdanosti po kojemu je Voditelj obrade odgovoran za usklađenost obrade podataka i mora ju biti u  mogućnosti dokazati. \r\nIzvršitelj obrade obvezuje se navedene izjave redovno ishoditi od svih osoba uključenih u obradu te o tome odmah obavijestiti Voditelja obrade i pružiti mu u tom smislu odgovarajuće dokaze. ',
                    value: '',
                },
        
            ],
            value: '',
        },   
        {
            title: 'TRAJANJE UGOVORA',
            mandatory: true,
            exampleContent: true,
            statements: [
                {
                    type: 'text',
                    required: true,
                    mandatory: true,
                    editable: true,
                    content: 'Odredbe ovog Ugovora prate pravnu sudbinu poslovnog odnosa iz uvodnih odredbi ovog Ugovora te prestankom navedenog poslovnog odnosa koji regulira usluge knjigovodstva, prestaju i odredbe ovog Ugovora, s izuzetkom obveze povjerljivosti, koja se primjenjuje trajno i nakon prestanka Ugovora.',
                    value: '',
                },
        
            ],
            value: '',
        },
        {
            title: 'NADLEŽNOST',
            mandatory: false,
            statements: [
                {
                    type: 'choice',
                    mandatory: true,
                    editable: false,
                    choices: [
                        {
                            parts: [
                                {
                                    type: 'text',
                                    content: 'Svi sporovi koji proizađu ili budu u vezi s ovim Ugovorom rješavati će se pred stvarno nadležnim sudom prema sjedištu Voditelja obrade.'
                                }
                            ]
                        },
                        {
                            parts: [
                                {
                                    type: 'text',
                                    content: 'Svi sporovi koji proizađu ili budu u vezi s ovim Ugovorom rješavati će se pred stvarno nadležnim sudom prema sjedištu Izvršitelja obrade.'
                                }
                            ]
                        },
                        {
                            parts: [
                                {
                                    type: 'text',
                                    content: 'Svi sporovi koji proizađu ili budu u vezi s ovim Ugovorom rješavati će se pred stvarno nadležnim sudom u'
                                },
                                {type: 'input', value: '',help: "Upišite mjesno nadležni sud. Npr. sudom u Zagrebu; sudom u Splitu i sl..", required: true},
                    ]
                        }
                    ],
                    value: '',
                }
            ]
        },
        {
            title: 'MJERODAVNO PRAVO',
            mandatory: false,
            statements: [
                {
                    type: 'text',
                    required: false,
                    mandatory: true,
                    editable: true,
                    content: 'Na prava i obveze ugovornih stranaka, koja nisu uređena ovim Ugovorom, primjenjuju se odredbe Zakona o obveznim odnosima te odredbe Uredbe.',
                    value: '',
                }],
        },
        {
            title: 'PRIMJENA UGOVORA',
            mandatory: false,
            statements: [
                {
                    type: 'text',
                    required: false,
                    mandatory: true,
                    editable: true,
                    content: 'Ovaj Ugovor se primjenjuje od trenutka potpisa ugovornih strana.',
                    value: '',
                }],
        },
        {
            title: 'PRIMJERCI UGOVORA',
            mandatory: false,
            statements: [
                {
                    type: 'text',
                    required: false,
                    mandatory: true,
                    editable: true,
                    content: 'Ovaj Ugovor sastavljen je u 2 (dva) primjerka, od kojih svaka ugovorna strana zadržava po 1 (jedan) primjerak.',
                    value: '',
                }],
          },
        {
            mandatory: true,
            static: true,
            type: 2, // date and place
            statements: [
                {
                    type: 'input',
                    mandatory: true,
                    parts: [
                        {
                            type: 'text',
                            content: 'U'
                        },
                        {
                            type: 'input',
                            value: '',
                            placeholder: "Upišite mjesto.",
                            required: true
                        },
                        {
                            type: 'text',
                            content: ', dana'
                        },
                        {
                            type: 'date',
                            value: new Date(),
                            required: true
                        },
                        {
                            type: 'text',
                            content: 'godine.'
                        }
                    ]
                },
            ]
        },
        {
            mandatory: true,
            static: true,
            type: 3,  // signatures
            statements: [],
        },
    ],
};



// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/91_ugovor_o_GDPR_izvrsitelj.ts